const nl = {
  lng_name: 'Dutch',
  item_id_does_not_exist: 'Item {{id}} bestaat niet in uw Kaltura item lijst of is verwijderd.',
  your_kaltura_item_list_is_empty: 'Uw Kaltura item lijst is leeg.',
  purchase: 'kopen',
  purchased: 'aangekocht',
  go_to: 'Ga Naar',
  login_signup: 'Log in/Registreren',
  logout: 'Uitloggen',
  please_wait: 'Een moment geduld alstublieft...',
  thank_you_for_your_purchase: 'Hartelijk dank voor uw aankoop',
  buy_more_channels: 'Koop meer kanalen',
  go_to_premium_content: 'Ga naar premium inhoud',
  go_to_purchased_channels: 'ga naar aangekochte kanalen',
};

export default nl;